import { ViewTransitionLink } from "../components/ViewTransitionLink"
import { SplashTemplate } from "../templates/SplashTemplate"

export function NotFoundPage() {
  return (
    <SplashTemplate title="404 - Page Not Found">
      <h1>Page Not Found</h1>
      <p>The page you requested does not exist.</p>
      <p>
        <ViewTransitionLink to="/">Return to Home</ViewTransitionLink>
      </p>
    </SplashTemplate>
  )
}
